// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8SyLS","importantInfo":"styles_importantInfo__3FqQl"};